module.exports = __webpack_public_path__ + "static/media/book-mock-fr.8d1ef980.png";